import Diagram from "@/components/Diagram";
import React from "react";

export default function Graph({items}) {
  return (
    <section className=" container mt-2 py-12 px-6 flex gap-[10px] rounded-lg dark:bg-dark-surface1 bg-surface1 lg:flex-row flex-col-reverse">
    <div className=" flex justify-center w-full">
      <Diagram items={items}/>
    </div>
    </section>
  );
}
